import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'getValue', pure: true })
export class GetValuePipe implements PipeTransform {
  transform = (value: string): string => (value ? value : '');
}
